import { DashboardCard2 } from "@/components/layout/DashboardCard2";

const labelMap = {
  current_housing: "Current Housing",
  current_living: "Current Living",
  education: "Education Completed",
  employment_status: "Employed",
  marital_status: "Marital Status",
  military_background: "Military Background",
  pcp_location: "PCP Location",
  pcp_name: "PCP",
  race_ethnicity: "Race, Ethnicity",
  sexual_orientation: "Sexual Orientation",
};

export function DemographicsCard({ demographics }) {
  if (!demographics) return null;

  return (
    <DashboardCard2 rawChildren>
      <dl className="tw:grid tw:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] tw:gap-x-7 tw:gap-y-6 tw:lg:px-4">
        {Object.entries(demographics).map(([key, value]) => {
          if (!(key in labelMap) || value === null || value === undefined || value === "")
            return null;

          return (
            <div className="tw:flex tw:flex-col tw:text-sm" key={key}>
              <dt className="tw:font-bold">{labelMap[key]}</dt>
              <dd className="tw:m-0">{Array.isArray(value) ? value.join(", ") : value}</dd>
            </div>
          );
        })}
      </dl>
    </DashboardCard2>
  );
}
